//
//
//
//
//
//

export default {
  props: {
    isRounded: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes () {
      return {
        BaseCard: true,
        'BaseCard--rounded': this.isRounded
      }
    }
  }
}
